import { Box, Typography } from '@mui/material';
import { ArrowUp } from 'phosphor-react';
import ReactApexChart from 'react-apexcharts';
import { CashFlowChart } from '../../Utilis/Types/CashFlow';
import { numberFormat } from '../../Utilis/numberFormater';

type Props = {
  chart: CashFlowChart[];
};

const WealthImpactChart = ({ chart }: Props) => {
  if (!chart || chart.length === 0) {
    return null;
  }

  const options: ApexCharts.ApexOptions | undefined = {
    series: [
      {
        name: 'Base Total Portofolio Assets',
        data: [...chart?.map(item => item?.base_total_portfolio_assets)],
        color: '#3293DB',
      },
      {
        name: 'Projected Total Portofolio Assets',
        data: [
          ...chart?.map(
            item =>
              item?.projected_total_portfolio_assets -
              item?.base_total_portfolio_assets
          ),
        ],
        color: '#52AB98',
      },
    ],

    tooltip: {
      shared: true,
      intersect: false,

      y: [
        {
          formatter(val) {
            return `$${numberFormat(val)}`;
          },
        },
        {
          formatter(val, opts) {
            const optsSeriesOne = opts?.series?.[0];

            const valuePlusSeriesOne =
              val + optsSeriesOne?.[opts.dataPointIndex];

            return `$${numberFormat(valuePlusSeriesOne)}`;
          },
        },
      ],

      x: {
        formatter(val, opts) {
          return `Year ${val}`;
        },
      },
    },
    chart: {
      type: 'bar',
      stacked: true,
      redrawOnParentResize: true,
      width: 480,
      height: 250,
      toolbar: {
        show: true,
      },
      zoom: {
        enabled: true,
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],

    legend: {
      show: false,
    },
    dataLabels: {
      enabled: false,
    },
    plotOptions: {
      bar: {
        horizontal: false,
      },
    },
    yaxis: {
      labels: {
        formatter: value => {
          const millionValue = value / 1000000;
          if (millionValue === 0) return '';

          return `$${millionValue}m`;
        },
      },
    },
    xaxis: {
      type: undefined,
      categories: [...chart?.map(item => item.year)],
      labels: {
        formatter: (value: string): string | string[] => {
          const year = parseInt(value);

          if (year % 5 === 0) {
            return [year.toString()];
          }

          return [];
        },
      },
    },

    fill: {
      opacity: 1,
    },
  };

  return (
    <Box
      sx={{
        padding: '24px',
        maxWidth: '605px',
        width: '100%',
        textAlign: 'center',
        '@media(max-width:768px)': {
          padding: 0,
        },
      }}
    >
      <ReactApexChart options={options} series={options?.series} type='bar' />
    </Box>
  );
};

export default WealthImpactChart;
